module.exports = __webpack_public_path__ + "img/SHOPING_BAG.fc927759.png";